<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="6"
      >
        <v-carousel
          height="450"
          hide-delimiter-background
          class="cara"
        >
          <v-carousel-item
            eager
            v-for="imgn in item.images"
            :key="imgn.id"
            :src="`${apiBaseUrl}/uploads/${imgn.path}`"
          />
        </v-carousel>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="6"
      >
        <v-list-item three-line>
          <v-list-item-content>
            <BaseBreadcrumbs :crumbs="crumbs" class="px-0"/> 
            <v-list-item-title class="headline mb-1">
              {{item.ten_sp}}
            </v-list-item-title>
            <v-list-item-subtitle>Giá tham khảo: 
              <span v-if="item.gia_ban > 0">{{item.gia_ban | currency('đ')}}</span>
              <span v-else>Liên hệ</span>
            </v-list-item-subtitle>
            <div class="mt-2">
              <v-chip 
                v-if="item.product_type"
                label
                small
              >
                <v-icon left small color="primary">
                  mdi-tag
                </v-icon>
                {{item.product_type.ten_loai}}
              </v-chip>
            </div>
          </v-list-item-content>
        </v-list-item>
        <v-row>
          <v-col cols="12">
            <v-card :elevation="2">
              <v-card-title class="subheading font-weight-bold justify-center">
                Thông tin nhà cung cấp
              </v-card-title>
              <v-list v-if="item.business" dense>
                <v-list-item>
                  <v-list-item-content class="font-weight-bold">Nhà cung cấp:</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{item.business.ten_co_so}}
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="font-weight-bold">Địa chỉ:</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{item.business.dia_chi}}
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="font-weight-bold">Điện thoại:</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{item.business.so_dien_thoai}}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card flat>
          <v-tabs
            v-model="tabs"
            class="rounded-t-lg"
            color="primary"
            background-color="primary"
            dark
            fixed-tabs
          >
            <v-tabs-slider/>
            <v-tab>
              Thông tin chi tiết sản phẩm
            </v-tab>
            <v-tab>
              Giấy chứng nhận
            </v-tab>
            <v-tab>
              Nhà phân phối/Cơ sở hợp tác
            </v-tab>
            <v-tab>
              Bản đồ truy xuất
            </v-tab>
            <v-tab-item class="mt-2">
              <v-row>
                <v-col cols="12">
                  <v-sheet class="elevation-1">
                    <v-card flat class="mx-auto text-center">
                      <v-card-text>
                        <v-row>
                          <v-col
                            cols="6"
                          >
                            <v-card flat>
                              <v-list dense>
                                <v-list-item>
                                  <v-list-item-content class="font-weight-bold">Tên sản phẩm:</v-list-item-content>
                                  <v-list-item-content class="align-end">
                                    {{item.ten_sp}}
                                  </v-list-item-content>
                                </v-list-item>

                                <v-list-item>
                                  <v-list-item-content class="font-weight-bold">Tên giống:</v-list-item-content>
                                  <v-list-item-content class="align-end">
                                    {{item.ten_giong}}
                                  </v-list-item-content>
                                </v-list-item>

                                <v-list-item>
                                  <v-list-item-content class="font-weight-bold">Giá tham khảo:</v-list-item-content>
                                  <v-list-item-content class="align-end">
                                    {{item.gia_ban}}
                                  </v-list-item-content>
                                </v-list-item>

                                <v-list-item>
                                  <v-list-item-content class="font-weight-bold">Cách bảo quản:</v-list-item-content>
                                  <v-list-item-content class="align-end" v-html="item.cach_bao_quan"/>
                                </v-list-item>
                              </v-list>
                            </v-card>
                          </v-col>
                          <v-col cols="6">
                            <v-card flat>
                              <v-list dense>
                                <v-list-item>
                                  <v-list-item-content class="font-weight-bold">Hạn sử dụng:</v-list-item-content>
                                  <v-list-item-content class="align-end">
                                    {{item.han_su_dung}}
                                  </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-content class="font-weight-bold">Nguồn gốc:</v-list-item-content>
                                  <v-list-item-content class="align-end">
                                    {{item.nguon_goc}}
                                  </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-content class="font-weight-bold">Chức năng / công dụng sản phẩm:</v-list-item-content>
                                  <v-list-item-content class="align-end" v-html="item.cong_dung"/>
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-content class="font-weight-bold">Loại sản phẩm:</v-list-item-content>
                                  <v-list-item-content class="align-end">
                                    {{item.product_type ? item.product_type.ten_loai : ''}}
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item class="mt-2">
              <v-alert
                v-if="!item.business || !item.business.cert_images.length"
                text
                class="text-center mt-2"
                color="red"
              >
                <v-icon left>
                  mdi-magnify
                </v-icon>
                Chưa có giấy chứng nhận!
              </v-alert>
              <v-row v-else>
                <v-col 
                  cols="12" 
                  sm="6"
                  md="auto"
                  v-for="(data, indx) in item.business.cert_images"
                  :key="indx"
                  class="mx-auto"
                >
                  <v-card
                    flat 
                    class="px-4 my-4"
                  >
                    <v-img
                      height="120"
                      width="120"
                      :src="`${apiBaseUrl}/uploads/${data.path}`"
                      lazy-src="@/assets/NoImage.jpg"
                      contain
                      class="mx-auto"
                    />
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item class="mt-2">
              <v-row>
                <v-col 
                  cols="12" 
                  sm="6"
                  md="auto"
                  v-for="(data, indx) in item.prod_distributors" 
                  :key="indx"
                  class="mx-auto"
                >
                  <v-card
                    flat 
                    class="px-4 my-4"
                  >
                    <v-img
                      height="120"
                      width="120"
                      src="@/assets/tglogo.png"
                      contain
                      class="mx-auto"
                    />
                    <v-card-title class="justify-center">
                      {{data.ten_npp}}
                    </v-card-title>
                    <v-card-subtitle class="justify-center">
                      {{data.dia_chi}}
                    </v-card-subtitle>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item class="mt-2">
              <MapTrace/>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialogQrZoom"
      persistent
      max-width="290"
    >
      <v-card>
        <v-app-bar
          dark
          color="primary"
        >
          <v-icon>
            mdi-tablet-cellphone
          </v-icon>
          <v-spacer/>
          <v-toolbar-title>Mã truy xuất</v-toolbar-title>
          <v-spacer/>
          <v-btn
            icon
            @click="closeZoomQrCode()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                v-if="qrItem"
                align="center"
                justify="center"
              >
                <qrcode-vue 
                  :value="GenerateURL(qrItem)" 
                  :size="170" 
                  level="H"
                />
                {{qrItem ? qrItem.ma_truy_xuat: null}}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import QrcodeVue from 'qrcode.vue';
  import MapTrace from './MapTrace.vue';
  import { mapState } from 'vuex';
  import {
    Hooper,
    Slide,
    Navigation as HooperNavigation
  } from 'hooper';
  import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs';
  export default {
    components: {
      QrcodeVue,
      MapTrace,
      Hooper,
      Slide,
      HooperNavigation,
      BaseBreadcrumbs
    },
    data: () => ({
      crumbs: [],
      model: 0,
      tabs: 0,
      item: {
        business: {
          cert_images: {

          }
        }
      },
      relatedItems: [],
      dialogQrZoom: false,
      qrItem: null,
      hooperSettings: {
        infiniteScroll: true,
        centerMode: true,
        wheelControl: false,
        breakpoints: {
          2400: {
            itemsToShow: 8
          },
          1800: {
            itemsToShow: 6
          },
          1500: {
            itemsToShow: 5
          },
          1100: {
            itemsToShow: 4
          },
          768: {
            itemsToShow: 3
          },
          576: {
            itemsToShow: 2
          },
          0: {
            itemsToShow: 2
          }
        }
      },
    }),
    computed: {
      ...mapState([
        'config'
      ]),
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    mounted() {
      axios.get(`api/v1/public/products/${this.$route.params.id}`)
        .then(response => {
          this.item = response.data;
          this.crumbs = [
            {
              text: 'Sản phẩm',
              disabled: false,
              href: '/products/tracing',
            },
            {
              text: this.item.ten_sp,
              disabled: true
            }
          ];
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    methods: {
      getRelatedItems(){
        axios.get(`api/v1/public/products-related/${this.$route.params.id}`)
          .then(response => {
            this.relatedItems = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      GenerateURL(){
        let path = this.$router.resolve({
          name: 'ProductTrace', 
          params: {
            id: this.item.id
          }
        });
        return `${window.location.origin}/${path.href}`;
      },
      addToCart(item) {
        this.$store.commit('addToCart', item);
        this.$router.push({ name: 'Cart' });
      },
      zoomQrCode(item){
        this.dialogQrZoom=true;
        this.qrItem=item;
      },
      closeZoomQrCode(){
        this.dialogQrZoom=false;
      },
    }
  }
</script>

<style>
  .v-card--flat {
    box-shadow: 0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12) !important;
  }
  .cara .v-image__image--cover {
    background-size: contain;
  }
</style>
